export default function mapValuesObjectUtil (object, iteratee) {
  if (object == null) {
    return {}
  }

  const result = {}
  for (const [key, value] of Object.entries(object)) {
    result[key] = iteratee(value, key, object)
  }
  return result
}
